// Flight-pad helpers — read normalized FlightOffer fields only
// (see providers/index.js typedef). Provider-agnostic.

import { count_adults } from '@liveflight/providers';

export const carrier_iata = (itinerary, segment_index = 0) => {
  const { segments = [] } = itinerary || {};
  const index = segments.length <= segment_index ? 0 : segment_index;
  const { carrier = {} } = segments[index] || {};
  return carrier.code || '';
};

export const bags_quantity_color = (quantity = 0, active_color = '#39414E') =>
  quantity > 0 ? active_color : '#AAAAAA';

const first_fare_detail = (flight_offer) => {
  const { travelerPricings = [] } = flight_offer || {};
  const { fareDetailsBySegment = [] } = travelerPricings[0] || {};
  return fareDetailsBySegment[0] || {};
};

// Boolean presence indicator (1 when the offer has any adult, else 0).
// Per-adult multiplication happens on the sidebar resume row.
export const hand_bags_per_adult = (flight_offer) =>
  count_adults(flight_offer) > 0 ? 1 : 0;

export const luggage_bags_per_adult = (flight_offer) => {
  const { includedCheckedBags = {} } = first_fare_detail(flight_offer);
  return includedCheckedBags.quantity || 0;
};

export const cabin_bags_per_adult = (flight_offer) => {
  const { includedCabinBags = {} } = first_fare_detail(flight_offer);
  return includedCabinBags.quantity || 0;
};
